module.exports = __webpack_public_path__ + "static/comic-yellow-background-small-13a3a6af2552c0c3eb246da90ddff347.svg";